import type { IStandardErrorResponse } from 'src/api/common';
import { useMutation, useQueryClient } from 'react-query';

import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';
import { playbooksPath } from 'src/services/api/playbooks/path';
import { useNotifications } from 'src/notifications';

interface IUpdateBackgroundPlaybookOrderRequest {
    playbookUuids: string[];
}

export const useUpdateBackgroundPlaybooksOrder = () => {
    const queryClient = useQueryClient();
    const { addNotification } = useNotifications();

    return useMutation<void, IStandardErrorResponse, IUpdateBackgroundPlaybookOrderRequest>(
        async (payload) => {
            const json = { automation_uuids: payload.playbookUuids };
            await apiClient(`${playbooksPath}/order`, { method: 'patch', json });
        }, {
            onSuccess: () => {
                queryClient.invalidateQueries(queryKeys.playbooks);
                queryClient.invalidateQueries(queryKeys.teamPlaybooks);
                addNotification('Playbook order updated', 'success');
            }, onError: (error) => {
                queryClient.invalidateQueries(queryKeys.playbooks);
                queryClient.invalidateQueries(queryKeys.teamPlaybooks);
                const errorMessage = error.msg || 'Failed to update Playbook order';
                addNotification(errorMessage, 'error');
            }
        }
    );
};
